import React from 'react';
import PropTypes from 'prop-types';
import {GridItem} from '../components/shared/render';
import LongForm from '../components/shared/long-form';
import TopContentCard from '../components/cards/top-content';

const ContentCard = ({stackup, num}) => {
  return (
    <>
      {stackup && stackup.topContent && stackup.topContent !== '' && (
        <GridItem span={num}>
          <LongForm content={stackup.topContent} />
        </GridItem>
      )}

      {stackup && stackup.bottomContent && stackup.bottomContent !== '' && (
        <GridItem span={num}>
          <LongForm content={stackup.bottomContent} />
        </GridItem>
      )}

      {stackup && stackup.content1 && (
        <GridItem span={num}>
          <TopContentCard description={stackup.content1} />
        </GridItem>
      )}
    </>
  );
};

ContentCard.propTypes = {
  num: PropTypes.number,
  stackup: PropTypes.object
};

export default ContentCard;
